import _ from 'lodash'
import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import HeaderNavBar from 'components/header-nav-bar'

import AddDatesIcon from '../../../assets/icons/add-dates.svg'
import DetailsIcon from '../../../assets/icons/details.svg'
import EyeIcon from '../../../assets/icons/eye.svg'
import IntegrationsIcon from '../../../assets/icons/integrations.svg'
import ViewIcon from '../../../assets/icons/view.svg'
import BackArrowIcon from '../../../assets/icons/back-arrow.svg'

import styles from './event-header.css'

const EventHeader = ({
  showBottomBar,
  soldTickets,
  subtitle,
  title,
  totalPartnerShare,
  addNewDatesUrl,
  onAddEventClick,
  showEditLink,
  onEditClick,
  isRoot,
  onBackClick,
  showSummaryLink,
  onDetailsClick,
  onIntegrationClick,
  onViewUrlClick,
}) => (
  <div styleName="event-header">
    <RelayoutWrapper>
      <Relayout align="center">
        <RelayoutItem xl="10">

          <div styleName="content">
            <Relayout valign="bottom">
              <RelayoutItem lg="6">
                <div styleName={isRoot ? 'title-inactive' : 'title-active'} onClick={onBackClick}>
                  <BackArrowIcon styleName={isRoot ? 'arrow-inactive' : 'arrow-active'} />
                  {title}
                </div>
              </RelayoutItem>

              {subtitle &&
                <RelayoutItem lg="6" />
              }

              {subtitle &&
                <RelayoutItem lg="6">
                  <h2 styleName="subtitle">{subtitle}</h2>
                </RelayoutItem>
              }

              <RelayoutItem lg="6">
                <div styleName="numbers">
                  {!_.isNil(soldTickets) &&
                    <div styleName="meta">
                      Tickets sold: <span styleName="value">{soldTickets}</span>
                    </div>
                  }
                  {!_.isNil(totalPartnerShare) &&
                    <div styleName="meta">
                      Revenue: <span styleName="value">{totalPartnerShare}</span>
                    </div>
                  }
                </div>
              </RelayoutItem>

              {showBottomBar &&
                <RelayoutItem>
                  <div styleName="bottom-bar">
                    {showEditLink &&
                      <div styleName="add-new-dates">
                        <HeaderNavBar
                          items={[{ label: 'EDIT', active: true, icon: <EyeIcon />, onClick: onEditClick }]}
                        />
                      </div>
                    }

                    {!showEditLink && addNewDatesUrl &&
                      <div styleName="add-new-dates">
                        <HeaderNavBar
                          items={[{
                            label: 'Add Dates',
                            active: true,
                            icon: <AddDatesIcon />,
                            onClick: onAddEventClick,
                          }]}
                        />
                      </div>
                    }

                    {showSummaryLink &&
                      <div styleName="summary">
                        <HeaderNavBar
                          items={[
                            { label: 'Details', icon: <DetailsIcon />, onClick: onDetailsClick },
                            { label: 'Integrations', icon: <IntegrationsIcon />, onClick: onIntegrationClick },
                          ]}
                        />
                      </div>
                    }

                    {onViewUrlClick &&
                      <div styleName="preview">
                        <HeaderNavBar
                          items={[{
                            label: 'View URL',
                            secondary: true,
                            icon: <ViewIcon />,
                            onClick: onViewUrlClick,
                          }]}
                        />
                      </div>
                    }
                  </div>
                </RelayoutItem>
              }
            </Relayout>
          </div>

        </RelayoutItem>
      </Relayout>
    </RelayoutWrapper>
  </div>
)

EventHeader.propTypes = {
  addNewDatesUrl: PropTypes.string,
  eventId: PropTypes.any,
  onAddEventClick: PropTypes.func,
  onBackClick: PropTypes.func,
  onDetailsClick: PropTypes.func,
  onIntegrationClick: PropTypes.func,
  onViewUrlClick: PropTypes.func,
  partnerId: PropTypes.any,
  showBottomBar: PropTypes.bool,
  soldTickets: PropTypes.any,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  totalPartnerShare: PropTypes.any,
  showEditLink: PropTypes.bool,
  onEditClick: PropTypes.func,
  isRoot: PropTypes.bool,
  showSummaryLink: PropTypes.bool,
}

export default CSSModules(EventHeader, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/event-header/event-header.js
 **/